module.exports = __webpack_public_path__ + "img/VN.6b8dcc71.svg";